<template>
    <l-control position="bottomleft">
        <div class="row mb-2 mx-2 px-1">
            <div class="col-auto badge blue-square text-white text-decoration-none small text-nowrap">
                0-50 km/h
            </div>
        </div>
        <div class="row my-2 mx-2 px-1">
            <div class="badge orange-square text-white text-decoration-none small text-nowrap">
                50-90 km/h
            </div>
        </div>
        <div class="row mt-2 mx-2 px-1">
            <div class="badge red-square text-white text-decoration-none small text-nowrap">
                90+ km/h
            </div>
        </div>
    </l-control>
</template>

<script>
import { LControl } from "@vue-leaflet/vue-leaflet";

export default {
    components: {
        LControl,
    },
}
</script>


<style>
.blue-square {
    background-color: #0d6efd;
    opacity: 0.65;
}

.orange-square {
    background-color: #ed8702;
    opacity: 0.65;
}

.red-square {
    background-color: #ed0202;
    opacity: 0.65;
}
</style>